import { api } from '@/api'
import { ISimpleResponse } from '@/modules/login/types'

export type DtpInputsData = {
  areaTypes: { id: number; name: string }[]
  types: { id: number; name: string }[]
  lightingTypes: { id: number; name: string }[]
  organizations: { id: number; name: string }[]
  regions: { id: number; name: string }[]
}

export type RoadAutocompleteResponse = {
  success: boolean
  data: string[]
}

export type UpdateTrafficAccidentRequest = {
  id: number
  number: number
  accidentDate: string | null
  regionId: number
  district: string | null
  road: string | null
  roadKilometer: number | null
  roadMeter: number | null
  latitude: number
  longitude: number
  type: string | null
  areaTypeId: number | null
  lightingType: string | null
  dead: number | null
  deadChildren: number | null
  injured: number | null
  injuredChildren: number | null
  imageId?: string
}

export type ImportTrafficAccidentsRequest = FormData

const dtpService = api.injectEndpoints({
  endpoints: (build) => ({
    getDtpFormData: build.query<DtpInputsData, void>({
      query: () => ({
        url: `${import.meta.env.VITE_API_URL}/api/devices/updateTrafficAccidents`,
        method: 'GET',
      }),
    }),
    getRoadAutocomplete: build.query<RoadAutocompleteResponse, string>({
      query: (search) => ({
        url: `${import.meta.env.VITE_API_URL}/api/devices/autocompleteRoads?value=${encodeURIComponent(search)}`,
        method: 'GET',
      }),
    }),
    updateTrafficAccident: build.mutation<
      ISimpleResponse,
      UpdateTrafficAccidentRequest
    >({
      query: (body) => ({
        url: `${import.meta.env.VITE_API_URL}/api/devices/updateTrafficAccidents`,
        method: 'POST',
        body,
      }),
    }),
    importTrafficAccidents: build.mutation<
      ISimpleResponse,
      ImportTrafficAccidentsRequest
    >({
      query: (body) => ({
        url: `${import.meta.env.VITE_API_URL}/api/devices/importTrafficAccidents`,
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetDtpFormDataQuery,
  useGetRoadAutocompleteQuery,
  useUpdateTrafficAccidentMutation,
  useImportTrafficAccidentsMutation,
} = dtpService
